<template>
  <div class="PodiumSettings mt-1">
    <v-autocomplete class="mb-3" outlined dense :value="settings.locationId" @input="(val) => setLocation(val)"
                    @click:append-outer="listLocations" item-text="name" item-value="uid" :items="locations" label="Location"
                    :append-outer-icon="loading ? 'mdi-loading mdi-spin' : 'mdi-reload'" clearable></v-autocomplete>
  </div>
</template>

<script>
import { helpers } from '@/mixins/helpers';
import 'vue-json-viewer/style.css';
import { createNamespacedHelpers } from 'vuex';

const { mapActions: workflowActions } =
  createNamespacedHelpers('workflows/list');

const { mapGetters: workspacesGetters } =
  createNamespacedHelpers('aiWorkspace');

export default {
  name: 'podium-send-message-settings',
  components: {},
  props: {},
  mixins: [helpers],
  data() {
    return {
      locations: [],
      loading: false,
    };
  },
  created() {
    this.locations.push({
      uid: this.settings.locationId,
      name: this.settings.locationName,
    });
  },
  computed: {
    ...workspacesGetters({
      selectedAction: 'SELECTED_ACTION',
      generalActions: 'WORKSPACE_GENERAL_ACTIONS',
    }),
    settings() {
      return this.selectedAction.settings;
    },
    action() {
      return this.selectedAction.action_type;
    },
  },
  methods: {
    ...workflowActions(['podiumAction']),
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
    setLocation(location) {
      const item = this.locations.find((item) => item.uid === location);
      this.onUpdate(item.name, 'settings.locationName');
      this.onUpdate(location, 'settings.locationId');
    },
    async listLocations() {
      this.loading = true;
      try {
        const data = {
          authenticationId: this.settings.authenticationId,
          action: 'list_locations',
        };
        const resp = await this.podiumAction(data);
        if (resp && resp.result) {
          this.locations = resp.result?.data || [];
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import './podium-settings';
</style>
